export const categoryPermissionsConst = {
  view: {
    value: "view_category",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu kategorii!",
  },
  add: {
    value: "add_category",
    errorMsg: "Użytkownik nie ma uprawnień do dodania kategorii!",
  },
  update: {
    value: "change_category",
    errorMsg: "Użytkownik nie ma uprawnień do edycji kategorii!",
  },
  delete: {
    value: "delete_category",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania kategorii!",
  },
};

export const productPermissionsConst = {
  view: {
    value: "view_product",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu produktów!",
  },
  add: {
    value: "add_product",
    errorMsg: "Użytkownik nie ma uprawnień do dodania produktów!",
  },
  update: {
    value: "change_product",
    errorMsg: "Użytkownik nie ma uprawnień do edycji produktów!",
  },
  delete: {
    value: "delete_product",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania produktów!",
  },
};

export const productgalleryPermissionsConst = {
  view: {
    value: "view_productgallery",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu galerii produktu!",
  },
  add: {
    value: "add_productgallery",
    errorMsg: "Użytkownik nie ma uprawnień do dodania galerii produktu!",
  },
  update: {
    value: "change_productgallery",
    errorMsg: "Użytkownik nie ma uprawnień do edycji galerii produktu!",
  },
  delete: {
    value: "delete_productgallery",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania galerii produktu!",
  },
};

export const productoptionpricePermissionsConst = {
  view: {
    value: "view_productoptionprice",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu cen opcji!",
  },
  add: {
    value: "add_productoptionprice",
    errorMsg: "Użytkownik nie ma uprawnień do dodania cen opcji!",
  },
  update: {
    value: "change_productoptionprice",
    errorMsg: "Użytkownik nie ma uprawnień do edycji cen opcji!",
  },
  delete: {
    value: "delete_productoptionprice",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania cen opcji!",
  },
};

export const packagePermissionsConst = {
  view: {
    value: "view_package",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu grup pakowania!",
  },
  add: {
    value: "add_package",
    errorMsg: "Użytkownik nie ma uprawnień do dodania grup pakowania!",
  },
  update: {
    value: "change_package",
    errorMsg: "Użytkownik nie ma uprawnień do edycji grup pakowania!",
  },
  delete: {
    value: "delete_package",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania grup pakowania!",
  },
};

export const productParameterPermissionsConst = {
  view: {
    value: "view_productparameter",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu parametrów produktu!",
  },
  add: {
    value: "add_productparameter",
    errorMsg: "Użytkownik nie ma uprawnień do dodania parametrów produktu!",
  },
  update: {
    value: "change_productparameter",
    errorMsg: "Użytkownik nie ma uprawnień do edycji parametrów produktu!",
  },
  delete: {
    value: "delete_productparameter",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania parametrów produktu!",
  },
};

export const productParameterOptionPermissionsConst = {
  view: {
    value: "view_productparameteroption",
    errorMsg:
      "Użytkownik nie ma uprawnień do odczytu opcji parametrów produktu!",
  },
  add: {
    value: "add_productparameteroption",
    errorMsg:
      "Użytkownik nie ma uprawnień do dodania opcji parametrów produktu!",
  },
  update: {
    value: "change_productparameteroption",
    errorMsg:
      "Użytkownik nie ma uprawnień do edycji opcji parametrów produktu!",
  },
  delete: {
    value: "delete_productparameteroption",
    errorMsg:
      "Użytkownik nie ma uprawnień do usuwania opcji parametrów produktu!",
  },
};

export const productQuantityPermissionsConst = {
  view: {
    value: "view_quantity",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu nakładów produktu!",
  },
  add: {
    value: "add_quantity",
    errorMsg: "Użytkownik nie ma uprawnień do dodania nakładów produktu!",
  },
  update: {
    value: "change_quantity",
    errorMsg: "Użytkownik nie ma uprawnień do edycji nakładów produktu!",
  },
  delete: {
    value: "delete_quantity",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania nakładów produktu!",
  },
};

export const productOptionGroupPermissionsConst = {
  view: {
    value: "view_productgroupoptions",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu grup opcji!",
  },
  add: {
    value: "add_productgroupoptions",
    errorMsg: "Użytkownik nie ma uprawnień do dodania grup opcji!",
  },
  update: {
    value: "change_productgroupoptions",
    errorMsg: "Użytkownik nie ma uprawnień do edycji grup opcji!",
  },
  delete: {
    value: "delete_productgroupoptions",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania grup opcji!",
  },
};

export const productOptionPermissionsConst = {
  view: {
    value: "view_productoption",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu opcji!",
  },
  add: {
    value: "add_productoption",
    errorMsg: "Użytkownik nie ma uprawnień do dodania opcji!",
  },
  update: {
    value: "change_productoption",
    errorMsg: "Użytkownik nie ma uprawnień do edycji opcji!",
  },
  delete: {
    value: "delete_productoption",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania opcji!",
  },
};

export const techlinePermissionsConst = {
  view: {
    value: "view_techline",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu linii technologicznych",
  },
  add: {
    value: "add_techline",
    errorMsg: "Użytkownik nie ma uprawnień do dodania linii technologicznych",
  },
  update: {
    value: "change_techline",
    errorMsg: "Użytkownik nie ma uprawnień do edycji linii technologicznych",
  },
  delete: {
    value: "delete_techline",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania linii technologicznych",
  },
};

export const exclusionPermissionsConst = {
  view: {
    value: "view_productoptionexclusion",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu wykluczeń!",
  },
  add: {
    value: "add_productoptionexclusion",
    errorMsg: "Użytkownik nie ma uprawnień do dodania wykluczeń!",
  },
  update: {
    value: "change_productoptionexclusion",
    errorMsg: "Użytkownik nie ma uprawnień do edycji wykluczeń!",
  },
  delete: {
    value: "delete_productoptionexclusion",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania wykluczeń!",
  },
};

export const discountPermissionsConst = {
  view: {
    value: "view_discount",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu rabatów!",
  },
  add: {
    value: "add_discount",
    errorMsg: "Użytkownik nie ma uprawnień do dodania rabatów!",
  },
  update: {
    value: "change_discount",
    errorMsg: "Użytkownik nie ma uprawnień do edycji rabatów!",
  },
  delete: {
    value: "delete_discount",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania rabatów!",
  },
};

export const discountNotePermissionsConst = {
  view: {
    value: "view_discountnote",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu notatek rabatów!",
  },
  add: {
    value: "add_discountnote",
    errorMsg: "Użytkownik nie ma uprawnień do dodania notatek rabatów!",
  },
  update: {
    value: "change_discountnote",
    errorMsg: "Użytkownik nie ma uprawnień do edycji notatek rabatów!",
  },
  delete: {
    value: "delete_discountnote",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania notatek rabatów!",
  },
};

// Dynamic prices exist only in this panel - TurnoverDiscountSettingViewSet
// allows reading and updating the settings.
export const turnoverDiscountSettingPermissionsConst = {
  view: {
    value: "view_turnoverdiscountsetting",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu dynamicznych cen!",
  },
  update: {
    value: "change_turnoverdiscountsetting",
    errorMsg: "Użytkownik nie ma uprawnień do edycji dynamicznych cen!",
  },
};
